<div class="modal modal--lg">
  <div class="modal__cont modal__cont--lg thanks">
    <button type="button" class="modal__close modal__close--alt" (click)="onClose()">
      <anduin-icon name="x" aria-hidden="true" height="24" stroke="currentColor" stroke-width="2" width="24" />
    </button>

    <div class="ta--center">
      <div class="mt--150 h2">Refund was successfully submitted!</div>
      <p class="mt--025">Refunds take 5–10 days to appear on a client’s statement.</p>
    </div>

    <div class="mt--200 grid-row grid-row--jcc">
      <div class="grid-col grid-col--auto">
        <button type="button" class="button button--lg button--primary" (click)="onClose()">Return to Payments</button>
      </div>
    </div>
  </div>
</div>
